import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Field } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { Button, FormGroup, Label } from "reactstrap";
import { InputField, ReactSelect, ToggleField, required } from "modules/4_final_form/web";
import LineItemsFields from "../web/LineItemsFields";
import _ from "lodash";
import { getMWJobs } from "modules/moneyworks/jobs/actions";
import { getEmployees } from "modules/employees/actions";

function mapStateToProps(state) {
  return {
    mw_jobs: state.mw_jobs,
    employees: state.employees,
  };
}

// ponytail: stacked layout for narrow Outlook taskpane; share LineItemsFields with web
const StoreRequestFormOutlook = (props) => {
  const { handleSubmit, formLabel, cancelFunction, mw_jobs, employees, values, form } = props;
  const toolAccount = !!values?.tool_account;

  useEffect(() => {
    if (_.isEmpty(mw_jobs)) {
      props.getMWJobs({ filterNines: true });
    }
    if (_.isEmpty(employees)) {
      props.getEmployees();
    }
  }, []);

  const jobOptions = useMemo(
    () =>
      _.map(_.sortBy(mw_jobs, "code"), (mw_job) => ({
        label: `${mw_job.code} - ${mw_job.description}`,
        value: mw_job.code,
      })),
    [mw_jobs],
  );

  const employeeOptions = useMemo(
    () =>
      _.map(_.sortBy(employees, ["last_name", "first_name"]), (emp) => ({
        value: emp.id,
        label: emp.display_name,
      })),
    [employees],
  );

  return (
    <form>
      <FormGroup>
        <Label>Tool Account</Label>
        <div>
          <Field component={ToggleField} name="tool_account" />
        </div>
      </FormGroup>
      <OnChange name="tool_account">
        {(value) => {
          if (value) {
            form.change("mw_job_id", null);
          } else {
            form.change("tool_account_employee_id", null);
          }
        }}
      </OnChange>

      {!toolAccount && (
        <FormGroup>
          <Label>Project</Label>
          <Field
            component={ReactSelect}
            name="mw_job_id"
            validate={required}
            options={jobOptions}
            virtualList
          />
        </FormGroup>
      )}

      {toolAccount && (
        <FormGroup>
          <Label>Employee</Label>
          <Field
            component={ReactSelect}
            name="tool_account_employee_id"
            validate={required}
            options={employeeOptions}
          />
        </FormGroup>
      )}

      <FormGroup>
        <Label>Notes</Label>
        <Field component={InputField} name="notes" type="textarea" parse={(v) => v} />
      </FormGroup>

      <hr />
      <LineItemsFields stacked />

      <hr />
      <Button color="success" onClick={handleSubmit} type="button" className="w-100" size="lg">
        {formLabel}
      </Button>
      <Button color="danger" onClick={cancelFunction} type="button" className="w-100 mt-2">
        Cancel
      </Button>
    </form>
  );
};

export default connect(mapStateToProps, { getMWJobs, getEmployees })(StoreRequestFormOutlook);
